import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import DASHBOARD_URL from "../common/Redirect";
import Base_URL from "../common/config2";
import { toast } from "react-toastify";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  // Check if Firebase is already loaded
  const [firebaseLoaded, setFirebaseLoaded] = useState(false);

  // Initialize Firebase when component mounts
  useEffect(() => {
    // Load Firebase SDK if not already loaded
    if (!window.firebase && !document.getElementById("firebase-script")) {
      const script = document.createElement("script");
      script.id = "firebase-script";
      script.src =
        "https://www.gstatic.com/firebasejs/9.22.0/firebase-app-compat.js";
      script.async = true;
      script.onload = () => {
        // Load Firebase Auth after Firebase App is loaded
        const authScript = document.createElement("script");
        authScript.src =
          "https://www.gstatic.com/firebasejs/9.22.0/firebase-auth-compat.js";
        authScript.async = true;
        authScript.onload = () => {
          initializeFirebase();
          setFirebaseLoaded(true);
        };
        document.body.appendChild(authScript);
      };
      document.body.appendChild(script);
    } else if (window.firebase) {
      setFirebaseLoaded(true);
    }
  }, []);

  // Initialize Firebase
  const initializeFirebase = () => {
    // Your Firebase configuration - replace with your actual config
    const firebaseConfig = {
      apiKey: "AIzaSyBAMtvrbKK1p7hTG1V2AYz2bpGpGDcUAMQ",
      authDomain: "clifai-cd683.firebaseapp.com",
      projectId: "clifai-cd683",
      storageBucket: "clifai-cd683.firebasestorage.app",
      messagingSenderId: "1001395506359",
      appId: "1:1001395506359:web:a819d14200c1de7aae5132",
      measurementId: "G-YH75BT5LTN",
    };

    // Initialize Firebase if it hasn't been initialized yet
    if (!window.firebase.apps.length) {
      window.firebase.initializeApp(firebaseConfig);
    }
  };

  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();

    // Clear any previous errors
    setError("");

    // Ensure email and password are not empty
    if (!email || !password) {
      setError("Email and password are required");
      return;
    }

    try {
      setIsLoading(true); // Start loading spinner

      // Send POST request to the authentication API
      const response = await axios.post(
        `${Base_URL}/auth/login`,
        { email: email, password },
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );
      console.log(response);

      // Handle successful response
      if (response.status === 200) {
        toast.success("Login Successful");
        // Get the user data from the response
        const encodedUserData = encodeURIComponent(
          JSON.stringify(response.data.user)
        );
        const encodedToken = encodeURIComponent(response.data.token);
        const encodedRefreshToken = encodeURIComponent(
          response.data.refreshToken
        );
        const userId = response.data.user._id;

        window.location.href = `${DASHBOARD_URL}/dashboard?userData=${encodedUserData}&userId=${userId}&token=${encodedToken}&refreshToken=${encodedRefreshToken}`;
      } else {
        toast.error(`Error: ${response.data.message || "An error occurred"}`);
      }
    } catch (err) {
      // Enhanced error handling
      if (!navigator.onLine) {
        toast.error(
          "No internet connection. Please check your network and try again."
        );
        setError(
          "No internet connection. Please check your network and try again."
        );
      } else if (err.response) {
        toast.error(
          `Error: ${err.response.data.message || "An error occurred"}`
        );
        console.error("Error response:", err.response);
        setError(
          err.response.data.message || "An error occurred. Please try again."
        );
      } else if (err.request) {
        // Request was made but no response received
        toast.error("Unable to reach the server. Please try again later.");
        setError("Unable to reach the server. Please try again later.");
      } else {
        console.error("Error:", err);
        setError("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsLoading(false); // Stop loading spinner
    }
  };

  // Google login function
  const handleGoogleLogin = async () => {
    if (!firebaseLoaded) {
      setMessage(
        "Error: Authentication service is still loading. Please wait a moment."
      );
      return;
    }

    setLoading(true);

    try {
      // Create Google Auth Provider
      const provider = new window.firebase.auth.GoogleAuthProvider();

      // Sign in with popup
      const result = await window.firebase.auth().signInWithPopup(provider);

      // Get Google user info
      const user = result.user;

      // Get the full ID token
      const googleIdToken = await user.getIdToken(true);

      console.log("Google ID Token length:", googleIdToken.length);
      console.log("Token preview:", googleIdToken.substring(0, 20) + "...");

      // Create the request body
      const requestBody = {
        token: googleIdToken,
        name: user.displayName,
        email: user.email,
        photo: user.photoURL,
      };

      console.log(
        "Request body:",
        JSON.stringify(requestBody).length,
        "characters"
      );

      // Send the token to your backend to either sign in or create a new account
      const response = await fetch(`${Base_URL}/auth/google-login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();
      console.log("Response from server:", data);

      if (response.ok) {
        toast.success("Login Successful");
        // Get the user data from the response
        const encodedUserData = encodeURIComponent(JSON.stringify(data.user));
        const encodedToken = encodeURIComponent(data.token);
        const encodedRefreshToken = encodeURIComponent(data.refreshToken || "");
        const userId = data.user._id;

        // Redirect to dashboard
        window.location.href = `${DASHBOARD_URL}/dashboard?userData=${encodedUserData}&userId=${userId}&token=${encodedToken}&refreshToken=${encodedRefreshToken}`;
      } else {
        setMessage(`Error: ${data.message}`);
        toast.error(`Error: ${data.message || "An error occurred"}`);
      }
    } catch (error) {
      toast.error(
        `Failed to login with Google. ${error.message || "Please try again."}`
      );
      if (error.code === "auth/popup-closed-by-user") {
        setMessage("Login canceled: You closed the Google login window.");
      } else if (error.code === "auth/popup-blocked") {
        setMessage(
          "Error: Pop-up was blocked by your browser. Please allow pop-ups for this site."
        );
      } else {
        setMessage(
          `Failed to login with Google. ${error.message || "Please try again."}`
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div>
        <section className="contact-us  " id="login-section">
          <div className="container">
            <div className="row justify-content-center ">
              <div className="col-11 col-md-6  ">
                <div
                  className="contact-form-panel"
                  style={{ marginTop: "100px" }}>
                  <div className="sec-heading centered">
                    <div className="content-area">
                      <h2 className="title wow fadeInUp " data-wow-delay=".4s">
                        Let's Get Started
                      </h2>
                      <p
                        className="subtitle-text wow fadeInUp"
                        data-wow-delay=".6s">
                        Not a member yet?{" "}
                        <Link to="/elevate-by-im" className="link">
                          Sign Up
                        </Link>
                      </p>
                    </div>
                  </div>

                  {message && (
                    <div
                      className={`done-msg ${
                        message.includes("Error") ? "error" : ""
                      }`}>
                      {message}
                    </div>
                  )}

                  <div
                    className="contact-form-inputs wow fadeInUp"
                    data-wow-delay=".6s">
                    <div className="custom-form-area input-boxed">
                      <form
                        className="main-form"
                        id="login-form"
                        onSubmit={handleLogin}>
                        <div className="row">
                          <div className="col-12">
                            <div className="input-wrapper">
                              <input
                                className="text-input"
                                id="user-email"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                              />
                              <label
                                className="input-label"
                                htmlFor="user-email">
                                {" "}
                                Email Address <span className="req">*</span>
                              </label>
                              <span className="b-border" />
                              <span className="error-msg" />
                            </div>
                          </div>

                          <div className="col-12">
                            <div className="input-wrapper">
                              <input
                                className="text-input"
                                id="user-password"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                              />
                              <label
                                className="input-label"
                                htmlFor="user-password">
                                {" "}
                                Password <span className="req">*</span>
                              </label>
                              <span className="b-border" />
                              <span className="error-msg" />
                            </div>
                          </div>

                          <div className="col-12 text-start mb-4">
                            <Link to="/forgot-password" className="link">
                              Forgot Password?
                            </Link>
                          </div>

                          <div className="col-12">
                            <button
                              className="btn-solid w-100"
                              type="submit"
                              name="UserSubmit"
                              disabled={loading}>
                              {loading ? "Logging in..." : "Log In"}
                            </button>
                          </div>

                          <div className="col-12 mt-4">
                            <button
                              type="button"
                              className="btn-outline w-100 d-flex align-items-center justify-content-center"
                              onClick={handleGoogleLogin}
                              disabled={loading || !firebaseLoaded}>
                              <div className="me-2">
                                <svg viewBox="0 0 24 24" width="18" height="18">
                                  <path
                                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                                    fill="#4285F4"
                                  />
                                  <path
                                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                                    fill="#34A853"
                                  />
                                  <path
                                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                                    fill="#FBBC05"
                                  />
                                  <path
                                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                                    fill="#EA4335"
                                  />
                                </svg>
                              </div>
                              {!firebaseLoaded
                                ? "Loading..."
                                : "Sign In with Google"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
